import { MovieFreeGLightbox } from "../common/image_gallery.js";
import { mbSocialSharing, socialSharing } from "../common/sharing";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	for (const gallery of document.querySelectorAll("._gallery-section")) {
		new MovieFreeGLightbox({
			selector: gallery.dataset.gallerySelector,
		});
	}

	if (document.querySelector(".social-share")) {
		// Social
		const fb = new socialSharing(
			document.querySelector(".social-share .social-facebook-share"),
			{ kind: "facebook" },
		);
		const x = new socialSharing(
			document.querySelector(".social-share .social-X-share"),
			{ kind: "x", suffix: "via @movieplayer_it" },
		);
		const tg = new socialSharing(
			document.querySelector(".social-share .social-telegram-share"),
			{ kind: "telegram" },
		);
		const wa = new socialSharing(
			document.querySelector(".social-share .social-whatsapp-share"),
			{ kind: "whatsapp" },
		);
	}
	const mb_share = document.querySelector("#_share-mb");
	if (mb_share) {
		mb_share.addEventListener("click", (event) => {
			event.preventDefault();
			mbSocialSharing(mb_share);
		});
	}
});
